<template>
  <div id="index" class="container" ref="page">
    <div class="bg" ref="bg">
      <slot name="main"></slot>
    </div>
    <!-- <div class="silder" v-if="showType == 2 || showType == 3" style="display:none;">
      <div class="silderShow" @click="silderShow" v-show="isShow"></div>
      <el-drawer :visible.sync="drawer" :direction="direction" :modal="false" :show-close="false" :withHeader="false" :size="size" @open="open" @close="close">
        <div class="silder_box">
          <div ref="silder_item" class="silder_box_item" v-for="item in silder_bar" :key="item.id" @click="changeModule(item.id)" :class="[active == item.id ? 'silder_box_item_current': '']">{{ item.name }}</div>
        </div>
        <div class="closeSilder" @click="closeBar"></div>
      </el-drawer>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      clientWidth: window.screen.width,
      screenHeight: window.screen.height,
      clientHeight: window.document.documentElement.clientHeight,
      drawer: false,
      direction: 'ltr',
      size: '10%',
      // size: '2.29rem',
      isShow: true,
      showType: '',
      silder_bar: [
        { id: 1, name: '畜牧产业' },
        { id: 2, name: '牧场管理' },
        { id: 3, name: '活蓄监管' },
        { id: 4, name: '仓单监管' },
        { id: 5, name: '交易数据' },
        { id: 6, name: '屠宰数据' },
        { id: 7, name: '品牌溯源' },
      ],
      bankInfo: {},
      active: '1',
      localStyle: '',
      background: {
        backgroundImage: '',
      //  backgroundImage: require('../assets/../assets/silder_utem_bg.png'),
        backgroundSize: '100% 100%'
      }
    }
  },
  props: {
    bg: String,
  },
  watch: {
    clientHeight() {
      //如果screenHeight 发生改变，这个函数就会运行
      this.changeFixed(this.clientWidth, this.screenHeight)
    },
  },
  mounted() {
    this.active = window.localStorage.getItem('active')
    // 获取当前类型
    this.userInfo = JSON.parse(window.localStorage.getItem("NMYDATAUSERINFO"));
    this.showType = this.userInfo.usertype
    this.$nextTick(() => {
      this.changeFixed(this.clientWidth, this.screenHeight)
    })
    window.onresize = () => {
      this.clientHeight = window.document.documentElement.clientHeight
    }
  },
  methods: {
    changeFixed(clientWidth, screenHeight) {
      if (this.bg) {
        this.$refs.bg.style.backgroundImage = 'url(' + this.bg + ')'
      }
      if (this.$refs.page && clientWidth / screenHeight > 1.7 && clientWidth / screenHeight < 1.8) {
        this.$refs.page.style.maxWidth = clientWidth + 'px'
        this.$refs.page.style.maxHeight = this.clientHeight + 'px'
        this.$refs.bg.style.maxWidth = clientWidth + 'px'
        this.$refs.bg.style.maxHeight = this.clientHeight + 'px'
      } else if (this.$refs.page) {
        this.$refs.page.style.maxWidth = 0 + 'px'
        this.$refs.page.style.maxHeight = 0 + 'px'
        this.$refs.bg.style.maxWidth = 0 + 'px'
        this.$refs.bg.style.maxHeight = 0 + 'px'
        this.$refs.page.style.maxWidth = 1920 + 'px'
        this.$refs.page.style.maxHeight = 1080 + 'px'
        this.$refs.bg.style.maxWidth = 1920 + 'px'
        this.$refs.bg.style.maxHeight = 1080 + 'px'
      }
    },
    silderShow() {
      this.drawer = true
    },
    open() {
      this.isShow = false
    },
    close() {
      this.isShow = true
    },
    closeBar() {
      this.drawer = false
    },
    changeModule(id) {
      switch (id) {
        case 1:
          console.log(id)
          this.active = 1;
           window.localStorage.setItem('active', this.active)
           
          break
        case 2:
          console.log(id);
          this.active = 2 
           window.localStorage.setItem('active', this.active)
          break
        case 3:
          console.log(id)
          this.$router.push({
            name: 'livingDetails',
            query:{
              id: this.bankInfo.id
            }
         })
         this.active = 3
          window.localStorage.setItem('active', this.active)
          break
        case 4:
          this.$router.push({
            name: 'warehouse',
            query:{
              id: this.bankInfo.id
            }
         })
         this.active = 4 
          window.localStorage.setItem('active', this.active)
          break
        case 5:
          this.$router.push({
          name: 'transaction',
          query:{
              id: this.bankInfo.id
          }
         })
         this.active = 5 
          window.localStorage.setItem('active', this.active)
          break
        case 6:
           this.$router.push({
            name: 'slaughter',
            query:{
              id: this.bankInfo.id
            }
         })
         this.active = 6 
          window.localStorage.setItem('active', this.active)
          break
        case 7:
          this.$router.push({
          name: 'sourceIndex',
          query: {
            id: this.bankInfo.id
          }
         })
         this.active = 7 
         window.localStorage.setItem('active', this.active)
          break
        default:
          break
      }
    },
  },
}
</script>
<style>
.el-drawer {
  background-size: 100% 100% !important;
  box-shadow: none !important;
}
.el-drawer__body {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
<style lang="scss" scoped>
.container {
  // background: #001725;
  width: 100%;
  // max-width: 1920px;
  height: 100vh;
  // max-height: 1080px;
  margin: 0 auto;
  // position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .silder {
    position: absolute;
    top: 0;
    left: 0;
    .silderShow {
      width: 0.28rem;
      height: 0.54rem;
      position: absolute;
      top: 517px;
      background: url('../assets/showSilderBar.png');
      background-size: 100% 100%;
      cursor: pointer;
    }
    //
    .silder_box {
      width: 1.54rem;
      height: 6rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      justify-content: space-around;
      .silder_box_item {
        width: 1.54rem;
        height: 0.63rem;
        text-align: center;
        line-height: 0.63rem;
        background-size: 100% 100%;
        color: #fff;
        font-size: 0.26rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        margin-left: 10px;
        cursor: pointer;
      }
      .silder_box_item_current {
        width: 1.54rem;
        height: 0.63rem;
        text-align: center;
        line-height: 0.63rem;
        background-size: 100% 100%;
        color: #fff;
        font-size: 0.26rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        margin-left: 10px;
        cursor: pointer;
      }
    }

    .closeSilder {
      width: 0.28rem;
      height: 0.54rem;
      background-size: 100% 100%;
      cursor: pointer;
      transform: rotate(180deg);
      margin-left: 15px;
    }
  }
  .bg {
    width: 100%;
    // max-width: 1920px;
    // height: 100vh;
    // max-height: 1080px;
    // background: url('../assets/bg-hhr.png');
    background-size: 100% 100%;
    background-position: center center;
  }
}
</style>
